import templateHtml from './two-factor-verification-simple-code-input.html';

const component = {};

component.template = templateHtml;
component.controllerAs = 'vm';
component.bindings = {
    onCodeChange: '&',
    onEnterKeyPressed: '&',
    twoFactorUserSettings: '='
};

function TwoFactorVerificationSimpleCodeInputController(KEYCODE) {
    const vm = this;
    
    vm.onKeyUp = function onKeyUp(event) {
        if (event.keyCode === KEYCODE.Enter) {
            vm.onEnterKeyPressed();
        }
    };

    vm.verificationCodeChanged = function verificationCodeChanged() {
        vm.onCodeChange();
    };
}

TwoFactorVerificationSimpleCodeInputController.$inject = ['KEYCODE'];

component.controller = TwoFactorVerificationSimpleCodeInputController;
export const TwoFactorVerificationSimpleCodeInputComponent = component;
